import { getListingLabel, getListingStyle } from '@/lib/games'

interface GameBadgeProps {
  game?: string
  listingType?: string
  productType?: string
  className?: string
}

function GameBadge({ listingType, productType, className = '' }: GameBadgeProps) {
  const style = getListingStyle(listingType)
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border-2 px-2.5 py-0.5 text-[10px] font-extrabold uppercase tracking-wide ${style.badge} ${className}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${style.dot}`} />
      {getListingLabel(listingType, productType)}
    </span>
  )
}

export default GameBadge
